import React from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { FileText, Info } from "lucide-react";

export default function PortalInvoices() {
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    (async () => {
      const r = await api.get("/portal/me/invoices");
      setData(r.data);
      setLoading(false);
    })();
  }, []);

  return (
    <div className="space-y-6" data-testid="portal-invoices-page">
      <div>
        <div className="text-xs font-mono uppercase tracking-[0.2em] text-blue-700">Billing</div>
        <h1 className="font-heading text-3xl font-bold text-slate-900 mt-1">Invoices</h1>
        <p className="text-slate-500 text-sm mt-1">Historical invoices synced from Xero.</p>
      </div>

      {loading ? (
        <div className="text-slate-500 font-mono text-sm">Loading…</div>
      ) : !data?.xero_connected ? (
        <Card className="border-amber-200 bg-amber-50/40">
          <CardContent className="p-6 flex items-start gap-4">
            <div className="h-10 w-10 rounded-md bg-amber-100 flex items-center justify-center flex-shrink-0">
              <Info className="h-5 w-5 text-amber-700" />
            </div>
            <div>
              <div className="font-heading text-base font-bold text-slate-900">Xero integration coming soon</div>
              <div className="text-sm text-slate-700 mt-1 leading-relaxed">
                {data?.message || "Once Xentra connects your account to Xero, your invoices will appear here automatically — including amounts, due dates and payment status."}
              </div>
              <div className="text-xs text-slate-500 font-mono mt-3">
                In the meantime, please contact your account manager for any billing queries.
              </div>
            </div>
          </CardContent>
        </Card>
      ) : data.invoices.length === 0 ? (
        <Card className="border-slate-200 p-12 text-center">
          <FileText className="h-10 w-10 text-slate-300 mx-auto mb-3" />
          <div className="font-heading text-lg text-slate-700">No invoices yet</div>
        </Card>
      ) : (
        <Card className="border-slate-200">
          <CardContent className="p-0">
            {/* Future: real invoice rows once Xero is connected */}
          </CardContent>
        </Card>
      )}
    </div>
  );
}
